<template>
  <div>
    <el-form v-if="forcer && itemState.isEditing(fieldName)" :inline="true" size="mini"
             style="display: inline-block" @submit.prevent.native="$refs.input.blur()">
      <!-- name -->
      <el-form-item-extended :validator="$v.value_" :label="label">
        <el-input :placeholder="fieldName" v-model.trim="value_" style="width: initial" ref="input"
                  @input="itemState.setEditValue(fieldName, $event); $v.value_.$touch();"
                  @blur="onBlur"
        >
        </el-input>
        <!--<el-button icon="el-icon-check" type="primary"
                   :disabled="$v.id_.$invalid"
                   @click.prevent="applyField('id')"></el-button>-->
      </el-form-item-extended>
    </el-form>
    <span v-else class="context-edit-link" title="edit-item-id"
          :class="{'modified': itemState.isModified(fieldName)}"
          @click="activateEdit">
      {{label}}: {{getField(itemState.currentItem, fieldName)}}
    </span>
  </div>
</template>

<script>
import getField from '@/utils/getField'

export default {
  name: 'EditableField',
  props: {
    fieldName: {
      type: String,
      required: true
    },
    itemState: {
      required: true
    },
    label: String,
    validator: {
      default () {
        return {}
      }
    }
  },
  watch: {
    'itemState.currentItem': function (newValue, oldValue) {
      if (newValue) {
        this.value_ = this.itemState.getEditValue(this.fieldName)
          ? this.itemState.getEditValue(this.fieldName) : newValue[this.fieldName]
      } else {
        this.value_ = null
      }
    }
  },
  data () {
    return {
      forcer: 1,
      value_: this.itemState.getEditValue(this.fieldName)
    }
  },
  validations () {
    return {
      value_: this.validator
    }
  },
  methods: {
    getField,
    activateEdit () {
      this.itemState.edit(this.fieldName)
      this.value_ = this.itemState.getEditValue(this.fieldName)
      this.forcer++
      this.$nextTick(() => this.$refs.input.focus())
    },
    onBlur () {
      if (!this.$v.value_.$invalid) {
        this.itemState.submit(this.fieldName)
        this.forcer++
      }
    }
  }
}
</script>

<style scoped>
  .modified {
    background-color: linen !important;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/EditableField.vue